import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=f1353e98"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports